export const DEFAULT_VEHICLE_TYPE = 'VEHICLETYPE_PASSENGER_CAR' as const;
